import React, { useContext, useState } from "react";
import firebase from "firebase/app";
import "firebase/auth";
import fireBaseConfig from "./firebase.config";
import "./Login.css";
import gicon from "../../assets/imgs/gicon.png";
import { UserContext } from "../../App";
import { useHistory, useLocation } from "react-router";
firebase.initializeApp(fireBaseConfig);

const Login = () => {
  const [user, setUser] = useContext(UserContext);
  const [hasAccount, setHasAccount] = useState(false);
  const [emailValidation, setEmailValidation] = useState(true);
  const [confirmPassValidation, setConfirmPassValidation] = useState(true);
  let history = useHistory();
  let location = useLocation();
  let { from } = location.state || { from: { pathname: "/" } };

  // ---------------------------------- Handle On Blur ------------------------ //
  const handleOnBlur = (e) => {
    const newUserInfo = { ...user };
    if (e.target.name === "name") {
      newUserInfo.name = e.target.value;
      setUser(newUserInfo);
    }
    if (e.target.name === "email") {
      const isEmailValid = /\S+@\S+\.\S+/.test(e.target.value);
      if (isEmailValid === true) {
        newUserInfo.email = e.target.value;
        setUser(newUserInfo);
      } else {
        newUserInfo.isEmailValid = false;
        setUser(newUserInfo);
      }
    }
    if (e.target.name === "password") {
      const isPasswordValid = e.target.value >= 8;
      if (isPasswordValid === true) {
        newUserInfo.password = e.target.value;
        setUser(newUserInfo);
      }
    }
    if (e.target.name === "confirmPass") {
      const isBothPassMatch = user.password === e.target.value;
      if (isBothPassMatch === true) {
        newUserInfo.isPasswordMatch = true;
        setUser(newUserInfo);
      } else {
        newUserInfo.isConfirmPassMatch = false;
        setUser(newUserInfo);
      }
    }
  };
  // ----------------x------------------ Handle On Blur ------------x------------ //

  // ---------------------------------- Validate form ------------------------ //
  // ----------------x------------------ Validate form ------------x------------ //

  // ---------------------------------- Handle Create a new Account ------------------------ //
  const handleCreateAccount = (event) => {
    event.preventDefault();
    if (user.isEmailValid === false) {
      setEmailValidation(!emailValidation);
    }
    if (user.isConfirmPassMatch === false) {
      setConfirmPassValidation(!confirmPassValidation);
    }
    if (user.email && user.isPasswordMatch === true) {
      firebase
        .auth()
        .createUserWithEmailAndPassword(user.email, user.password)
        .then((res) => {
          const newUserInfo = { ...user };
          newUserInfo.isLoggedIn = true;
          setUser(newUserInfo);
          history.replace(from);
          var currentUser = firebase.auth().currentUser;
          currentUser
            .updateProfile({
              displayName: user.name,
            })
            .then()
            .catch();
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };
  // ----------------x------------------ Handle Create a new Account ------------x------------ //

  // ---------------------------------- Handle Log in ------------------------ //
  const handleLogIn = (e) => {
    e.preventDefault();
    firebase
      .auth()
      .signInWithEmailAndPassword(user.email, user.password)
      .then((res) => {
        const newUserInfo = { ...user };
        newUserInfo.isLoggedIn = true;
        newUserInfo.name = res.user.displayName;
        setUser(newUserInfo);
        history.replace(from);
      })
      .catch((error) => {
        const newUserInfo = { ...user };
        newUserInfo.error = error.message;
        setUser(newUserInfo);
        console.log(newUserInfo.error);
      });
  };
  // ----------------x------------------ Handle Log in ------------x------------ //

  // ---------------------------------- Google Sign in ------------------------ //
  const handleGoogleSignIn = () => {
    var provider = new firebase.auth.GoogleAuthProvider();
    firebase
      .auth()
      .signInWithPopup(provider)
      .then((res) => {
        const newUserInfo = { ...user };
        newUserInfo.isLoggedIn = true;
        newUserInfo.name = res.user.displayName;
        setUser(newUserInfo);
        history.replace(from);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  // ----------------x------------------ Google Sign in ------------x------------ //

  return (
    <div className="login">
      <form action="" className="login-form">
        <p style={{ color: "red" }}>{user.error}</p>
        {hasAccount ? <h2>Login</h2> : <h2>Create an account</h2>}
        {!hasAccount && (
          <input
            type="text"
            name="name"
            placeholder="Name"
            className="login-form-input"
            onBlur={handleOnBlur}
          />
        )}
        {!emailValidation && <p style={{ color: "red" }}>Email is not valid</p>}
        <input
          type="email"
          name="email"
          placeholder="Email"
          className="login-form-input"
          onBlur={handleOnBlur}
        />
        <input
          type="password"
          name="password"
          placeholder="Password"
          className="login-form-input"
          onBlur={handleOnBlur}
        />
        {!confirmPassValidation && <p style={{ color: "red" }}>No match</p>}
        {!hasAccount && (
          <input
            type="password"
            name="confirmPass"
            placeholder="Confirm Password"
            className="login-form-input"
            onBlur={handleOnBlur}
          />
        )}
        <input
          type="submit"
          value={hasAccount ? "Login" : "Create an account"}
          className="login-form-input submit-input"
          onClick={hasAccount ? handleLogIn : handleCreateAccount}
        />
        <p>
          {hasAccount ? "Don't have an account?" : "Already have an account?"}
          <a
            href="/login"
            onClick={(e) => {
              e.preventDefault();
              setHasAccount(!hasAccount);
            }}
          >
            {hasAccount ? "Create an account" : "Login"}
          </a>
        </p>
      </form>
      <div className="login-form-or-div">
        <hr className="login-form-hr" />
        <p>Or</p>
        <hr className="login-form-hr" />
      </div>
      <div className="g-sign-in-div">
        <div className="g-img-div">
          <img src={gicon} alt="" />
        </div>
        <button onClick={handleGoogleSignIn}>Continue with Google</button>
      </div>
    </div>
  );
};

export default Login;
